import { addItemToCollection } from "directus/src/operations";

export async function createTeam({ item }) {
  try {
    const data = await addItemToCollection("teams", item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
